export const USE_CASES = [
    {
      label: "Trading app for my customers",
      value: "trading-app-for-my-customers",
    },
    {
      label: "Trading app for my company",
      value: "trading-app-for-my-company",
    },
    {
      label: "Investment research app",
      value: "investment-research-app",
    },
    {
      label: "Risk monitoring/compliance app",
      value: "risk-monitoring-compliance-app",
    },
    {
      label: "Financial data and analytics platform",
      value: "financial-data-and-analytics-platform",
    },
    {
      label: "Wealth management software",
      value: "wealth-management-software",
    },
    {
      label: "Web3/crypto application",
      value: "web3-crypto-application",
    },
    {
      label: "Other",
      value: "other",
    },
  ];